import React from "react";
import { Form, Select as AntSelect } from "antd";
import Props from "./Props";
import { generate, generateByKey } from "../../../../helpers/hash";

const UNIQUE_ID = generate();

const defaultConfig = {
  allowClear: true,
};

const Select: React.FC<Props> = ({ name, config: selectConfig }) => {
  const config = {
    ...defaultConfig,
    ...selectConfig,
  };

  let options = null;

  if (config.options) {
    options = config.options.map((option, index) => {
      return (
        <AntSelect.Option
          value={option.value}
          key={generateByKey(index.toString(), UNIQUE_ID)}
        >
          {option.title}
        </AntSelect.Option>
      );
    });
  }

  return (
    <Form.Item
      name={name}
      label={config.label}
      rules={config.validationRules}
      labelCol={{ span: 24 }}
      {...(config.extra || {})}
    >
      <AntSelect
        allowClear={config.allowClear}
        filterOption={(input, option) =>
          option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        placeholder={config.placeholder}
        showSearch={config.showSearch}
        defaultValue={config.defaultValue}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        {options}
      </AntSelect>
    </Form.Item>
  );
};

export default Select;
